import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex items-center w-full"
};
const _hoisted_2 = {
  class: "grow"
};
const _hoisted_3 = {
  key: 0,
  class: "grow overflow-y-auto w-full"
};
const _hoisted_4 = {
  key: 1
};
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
import SimpleActionSheetSeparator from "@/modules/vue/components/SimpleActionSheetSeparator.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleActionSheet',
  props: {
    hideTitle: {
      type: Boolean
    },
    hideCancel: {
      type: Boolean
    },
    noScrollbar: {
      type: Boolean
    },
    noTeleport: {
      type: Boolean
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const scrollbar = ref(null);
    const onUpdateShow = () => {
      if (scrollbar.value) {
        nextTick(() => scrollbar.value.scrollTo({
          top: 0
        }));
      }
    };
    const showState = ref(false);
    const show = () => showState.value = true;
    const hide = () => showState.value = false;
    const toggle = () => showState.value = !showState.value;
    const slots = useSlots();
    const useScrollbar = computed(() => !!slots.default && !props.noScrollbar);
    expose({
      show,
      hide,
      toggle
    });
    provide('hide', hide);
    provide('show', show);
    provide('toggle', toggle);
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      const _component_NScrollbar = _resolveComponent("NScrollbar");
      const _component_NDrawerContent = _resolveComponent("NDrawerContent");
      const _component_NDrawer = _resolveComponent("NDrawer");
      return _openBlock(), _createBlock(_Teleport, {
        to: "#app-outside",
        disabled: __props.noTeleport
      }, [_createVNode(_component_NDrawer, {
        show: showState.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showState.value = $event),
        placement: "bottom",
        class: _normalizeClass(["select-none drawer", {
          'with-scrollbar': _unref(useScrollbar)
        }]),
        "on-update:show": onUpdateShow
      }, {
        default: _withCtx(() => [_createVNode(_component_NDrawerContent, {
          "native-scrollbar": false
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString(_ctx.$t('actions')), 1)])]), _createVNode(_component_NButton, {
            secondary: "",
            size: "small",
            onClick: hide
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: _ctx.IconEnum.CloseOutline
            }, null, 8, ["icon"])]),
            _: 1
          })])]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["bottom-0 top-0 right-0 left-0 flex flex-col", {
              absolute: _unref(useScrollbar)
            }])
          }, [_renderSlot(_ctx.$slots, "default-wrapper", {}, () => [_ctx.$slots.default ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_unref(useScrollbar) ? (_openBlock(), _createBlock(_component_NScrollbar, {
            key: 0,
            ref_key: "scrollbar",
            ref: scrollbar,
            trigger: "none"
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
            _: 3
          }, 512)) : _renderSlot(_ctx.$slots, "default", {
            key: 1
          })])) : _createCommentVNode("", true)]), !__props.hideCancel ? (_openBlock(), _createBlock(SimpleActionSheetSeparator, {
            key: 0,
            class: "bg-gray-100 h-2"
          })) : _createCommentVNode("", true), _ctx.$slots.actions ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "actions")])) : _createCommentVNode("", true), !__props.hideCancel || _ctx.$slots.actions ? (_openBlock(), _createBlock(SimpleActionSheetSeparator, {
            key: 2,
            class: "bg-gray-100 h-2"
          })) : _createCommentVNode("", true), !__props.hideCancel ? (_openBlock(), _createBlock(SimpleActionSheetItem, {
            key: 3,
            color: _ctx.ColorEnum.Red,
            onClick: hide
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)]),
            _: 1
          }, 8, ["color"])) : _createCommentVNode("", true)], 2)]),
          _: 3
        })]),
        _: 3
      }, 8, ["show", "class"])], 8, ["disabled"]);
    };
  }
});